document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-carousel').forEach(function(Element,index){
    let productid = Element.dataset.id;
    let outer_carousel = Element.closest('.carousel-rowouter');
    let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
    let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
    let swiper = new Swiper(Element,{
      loop:eval(Element.dataset.loop),
      slidesPerView: "auto",
      navigation: {
        nextEl:nextbutton,
        prevEl:prevbutton,
      },
      a11y: false,
    })
    if(document.querySelectorAll('.prod-caro-tab li')){
      document.querySelectorAll('.prod-caro-tab li').forEach((tab) =>{
        let currentVal = tab.getAttribute('data-title');
        if(Element.closest('.carousel-rowouter').getAttribute('data-title') == currentVal){
          tab.addEventListener('click',function(e){
            e.preventDefault();
            e.stopImmediatePropagation();
            let tabsWithIsOpen = document.querySelectorAll(".prod-caro-tab li.active-tab");
            tabsWithIsOpen.forEach((tabWithIsOpen) => {
              tabWithIsOpen.classList.remove("active-tab");
            });
            tab.classList.add("active-tab");
            let currentCarousel = Element.closest('.carousel-rowouter').getAttribute('data-title');
            if(currentVal == currentCarousel){
              let carouselsWithIsOpen = document.querySelectorAll(".carousel-rowouter.active-carousel");
              carouselsWithIsOpen.forEach((carouselWithIsOpen) => {
                carouselWithIsOpen.classList.remove("active-carousel");
              });
              Element.closest('.carousel-rowouter').classList.add("active-carousel");
            }
            document.querySelectorAll('.product-carousel-main .prod-caro-btns').forEach((btns) =>{
              btns.querySelectorAll('li').forEach((btn) =>{
                let currentBtn = btn.getAttribute('data-title');
                if(currentVal == currentBtn){
                  let btnsWithIsOpen = btns.querySelectorAll("li.active-btn");
                  btnsWithIsOpen.forEach((btnWithIsOpen) => {
                    btnWithIsOpen.classList.remove("active-btn");
                  });
                  btn.classList.add("active-btn");
                }
              });
            });
            swiper.update();
          });
        }
      });
    }
  });
});